module.exports = __webpack_public_path__ + "img/jeep.008ca0bf.png";